import ActiveLink from "./ActiveLink";

export default function Tabs({
  items,
}: {
  items: {
    href: string;
    label: string;
  }[];
}) {
  return (
    <div className="text-sm font-medium text-center text-gray-700 border-b border-gray-200">
      <ul className="flex flex-wrap -mb-px">
        {items.map((item) => (
          <li key={item.href} className="me-2">
            <ActiveLink
              href={item.href}
              inactiveClassName="border-transparent"
              activeClassName="border-b-2 border-gray-300"
              className="inline-block p-4 rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
            >
              {item.label}
            </ActiveLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
